import { useDistributionReadOnlyDrawdownTableRetrieveSuspense } from "gen/endpoints/distributions/distributions";
import React from "react";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { DataTable } from "shared/components/table/data/DataTable";

interface DistributionReadOnlyDrawdownTableProps {
  fundFamilyId: string;
  fundFamilyEventId: string;
}

const DistributionReadOnlyDrawdownTable: React.FC<
  DistributionReadOnlyDrawdownTableProps
> = ({ fundFamilyId, fundFamilyEventId }) => {
  const { data: tableData } =
    useDistributionReadOnlyDrawdownTableRetrieveSuspense(
      fundFamilyId,
      fundFamilyEventId,
    );

  return (
    <TableBox>
      <TableBoxBody>
        <DataTable data={tableData} />
      </TableBoxBody>
    </TableBox>
  );
};

export default DistributionReadOnlyDrawdownTable;
